import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TablePagination from '@mui/material/TablePagination';
import TableFooter from '@mui/material/TableFooter';

import SearchIcon from '@mui/icons-material/Search';
//import XLSX from 'xlsx'; // Import xlsx library
import * as XLSX from 'xlsx';
import { fetchData, deleteData, activateData, DespatchData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import ReactPaginate from 'react-paginate';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa';
import { Tooltip } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';

function DespatchReport() {

    const history = useHistory();

    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    const tableRef = React.createRef();
    // const { isAuthenticated, companyId } = useAuth();
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);
    const formattedDate = new Date().toISOString().split('T')[0];
    const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
    const [routeId, setrouteId] = useState('');
    const [tripOptions, setTripOptions] = useState([]);
    const [selectedTrip, setSelectedTrip] = useState(null);
    const [route, setRoute] = useState('');
    const [salesman, setSalesman] = useState('');

    const [currentPage, setCurrentPage] = useState(0);
    const itemsPerPage = 10;

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const hasReadReportPermission = permissions.includes('Read Reports');


    useEffect(() => {
        fetchTripTypes();
    }, []);

    const fetchTripTypes = async () => {
        try {
            const response = await fetchData('CustomerOrderedItemAPI', `/${companyId}`, token);

            // Check if response is valid and has data
            if (response.responseCode === '1111' && Array.isArray(response.response_data)) {
                const options = response.response_data.map(trip => ({
                    value: trip.Id,
                    label: trip.Description
                }));
                setTripOptions(options);
            } else {
                console.warn('No trip data found');
            }
        } catch (error) {
            console.error('Error fetching trip types:', error.message);
            // Optionally set an error state here to notify the user
        }
    };

    const getCurrentDate = () => {
        const today = new Date();
        return `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
    };

    const handleRefreshClick = () => {

        // setToDate(getCurrentDate());
        // fetchData();
        window.location.reload();
    };

    const handleToDateChange = (event) => {
        const selectedDate = event.target.value;
        setToDate(selectedDate);

    }

    const [Corderdate, setCorderdate] = useState("");
    const [orderTakenby, setOrdertakenby] = useState("");

    const [filteredData, setFilteredData] = useState([]);

    const [hasExtraOrders, setHasExtraOrders] = useState(false);
    const [extraOrders, setExtraOrders] = useState([]);


    const handleTripChange = async (selectedOption) => {
        setSelectedTrip(selectedOption);

        if (!selectedOption) return; // Early return if no option is selected

        try {
            const response = await fetchData('OrderTypeDespatchAPI', `/${companyId}/${selectedOption.value}`, token);
            if (response.responseCode === '1111') {
                const dataArray = response.response_data;

                if (dataArray.length > 0) {
                    setData(dataArray);
                    setCorderdate(dataArray[0].OrderDate); // Changed index from 1 to 0 to avoid out-of-bounds error
                    setOrdertakenby(dataArray[0].OrderTakenBy);
                    setRoute(dataArray[0].RouteName);
                    setSalesman(dataArray[0].Executive);

                    // Update filtered data based on selected trip
                    setFilteredData(dataArray.filter(item => item.route === selectedOption.value));
                }
                console.log(response);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
        }
    };


    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };
    //search
    const searchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    // Define filteredDataItem within the component
    const filteredDataItem = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const closeModal = () => {
        setShowModal(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    //search
    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write('<html><head><title>Despatch Summary</title></head><body>');
        printWindow.document.write('<h3 style="font-family: Times New Roman; font-size: 32px;">Despatch Summary</h3>');

        // Print route, order taken by, salesman, and order date above the table
        if (data.length > 0) {
            const firstRow = data[0]; // Use the first row for common details
            printWindow.document.write('<div style="margin-bottom: 20px;">');
            printWindow.document.write(`<p style="font-size: 18px;"><strong>Route:</strong> ${firstRow.RouteName || ''}</p>`);
            printWindow.document.write(`<p style="font-size: 18px;"><strong>Order Taken by:</strong> ${firstRow.OrderTakenBy || ''}</p>`);
            printWindow.document.write(`<p style="font-size: 18px;"><strong>Sales Executive:</strong> ${firstRow.Executive || ''}</p>`);
            printWindow.document.write(`<strong>Order Date:</strong> ${formatDate(firstRow.OrderDate)} &nbsp; | &nbsp; `);
            //printWindow.document.write(`<p style="font-size: 18px;"><strong>Order Date:</strong> ${firstRow.OrderDate ? new Date(firstRow.OrderDate).toLocaleDateString('en-GB') : ''}</p>`);
            printWindow.document.write('</div>');
        }

        // Now print the table header and body
        printWindow.document.write('<table style="border-collapse: collapse; width: 100%;">');
        printWindow.document.write('<thead style="background-color: #f3f3f3;">');
        printWindow.document.write('<tr>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sl.No</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Order Type</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Product Category</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Category(Variant)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item Code</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Item</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">UOM (Kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Bundle</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Pieces</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Quantity(pcs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Total Quantity(kgs)</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Active Customers</th>');
        printWindow.document.write('<th style="border: 1px solid #ddd; font-size: 19px; font-weight: bolder; color: black;">Sale Remarks</th>');
        printWindow.document.write('</tr>');
        printWindow.document.write('</thead>');
        printWindow.document.write('<tbody>');

        // Loop through data to generate rows with conditional logic
        let previousValues = {
            OrderTypeName: '',
            ProductCategory: '',
            Category: '',
            CustomerId: '',
            SaleRemarks: ''
        };

        data.forEach((rowData, index) => {
            printWindow.document.write('<tr>');
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${index + 1}</td>`); // Sl.No
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.OrderTypeName !== previousValues.OrderTypeName ? rowData.OrderTypeName : ''}</td>`); // Order Type
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ProductCategory !== previousValues.ProductCategory ? rowData.ProductCategory : ''}</td>`); // Product Category
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Category !== previousValues.Category ? rowData.Category : ''}</td>`); // Category
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.ItemCode || ''}</td>`); // Item Code
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Item || ''}</td>`); // Item
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Kilogram || ''}</td>`); // UOM (Kgs)
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Bundle || '0'}</td>`); // Bundle
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Pieces || '0'}</td>`); // Pieces
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.Quantity || ''}</td>`); // Quantity
            printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.TotalKilogram || ''}</td>`); // Total Quantity

            if (rowData.CustomerId) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.CustomerId !== previousValues.CustomerId ? rowData.CustomerId : ''}</td>`);
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }
            if (rowData.SaleRemarks) {
                printWindow.document.write(`<td style="border: 1px solid #ddd; font-size: 16px;">${rowData.SaleRemarks !== previousValues.SaleRemarks ? rowData.SaleRemarks : ''}</td>`); // Sale Remarks
            } else {
                printWindow.document.write('<td style="border: 1px solid #ddd; font-size: 16px;"></td>');
            }

            printWindow.document.write('</tr>');

            // Update previous values for the next iteration
            previousValues = {
                OrderTypeName: rowData.OrderTypeName,
                ProductCategory: rowData.ProductCategory,
                Category: rowData.Category,
                CustomerId: rowData.CustomerId,
                SaleRemarks: rowData.SaleRemarks
            };
        });

        printWindow.document.write('</tbody></table></body></html>');
        printWindow.document.close();
        printWindow.print();
    };


    const handleExportExcel = () => {
        const excelData = [];

        // Add route, order taken by, order date, and executive as a separate header row
        const topRow = [
            `Route: ${data[0].RouteName}`, // Assuming RouteName is the same for all entries
            `Order Date: ${data[0].OrderDate}`, // Assuming the same OrderDate for all entries
            `Order Taken by: ${data[0].OrderTakenBy}`, // Assuming the same person took all orders
            `Sales Executive: ${data[0].Executive}` // Assuming the same Sales Executive for all entries
        ];

        // Push this information to the first row
        excelData.push(topRow);

        // Add an empty row to separate this information from the rest of the table
        excelData.push([]);

        // Add header row for table data
        const headerRow = [
            'Sl.No', '', 'Product Category', 'Category(Variant)', 'Item Code', 'Item', 'UOM (Kgs)', 'Bundle', 'Pieces', 'Quantity(pcs)', 'Total Quantity(kgs)', 'Active Customers', 'Sale Remarks'
        ];
        excelData.push(headerRow);

        // Add data rows with conditional display logic
        let previousValues = {
            OrderTypeName: '',
            ProductCategory: '',
            Category: '',
            CustomerId: '',
            SaleRemarks: ''
        };

        data.forEach((rowData, index) => {
            const dataRow = [
                index + 1, // Sl.No
                rowData.OrderTypeName !== previousValues.OrderTypeName ? rowData.OrderTypeName : '', // Order Type
                rowData.ProductCategory !== previousValues.ProductCategory ? rowData.ProductCategory : '', // Product Category
                rowData.Category !== previousValues.Category ? rowData.Category : '', // Category
                rowData.ItemCode, // Item Code
                rowData.Item, // Item
                rowData.Kilogram, // UOM (Kgs)
                rowData.Bundle || '0', // Bundle
                rowData.Pieces || '0', // Pieces
                rowData.Quantity, // Quantity
                rowData.TotalKilogram, // Total Quantity
                rowData.CustomerId !== previousValues.CustomerId ? rowData.CustomerId : '', // Active Customers
                rowData.SaleRemarks !== previousValues.SaleRemarks ? rowData.SaleRemarks : '' // Sale Remarks
            ];

            // Push the dataRow to excelData
            excelData.push(dataRow);

            // Update previous values for the next iteration
            previousValues = {
                OrderTypeName: rowData.OrderTypeName,
                ProductCategory: rowData.ProductCategory,
                Category: rowData.Category,
                CustomerId: rowData.CustomerId,
                SaleRemarks: rowData.SaleRemarks
            };
        });

        // Create worksheet
        const ws = XLSX.utils.aoa_to_sheet(excelData);

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Despatch Report');

        // Save workbook to a file
        XLSX.writeFile(wb, 'Despatch.xlsx');
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(150); // Rows per page

    // Define initial column order
    const [columnOrder, setColumnOrder] = useState([
        'SL',
        '',
        'PDT .Category',
        'Category',
        'Code',
        'Item',
        'UOM(kgs)',
        'Bundle',
        'Pieces',
        'QTY(No.Pieces)',
        'Total QTY(kgs)',
        'Active Customers',
        'Remarks'
    ]);
    // Process and paginate the data
    const processedData = searchfilteredData.slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
    );


    // Handle page change
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    // Handle rows per page change
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page
    };

    // Function to handle drag start
    const handleDragStart = (e, index) => {
        e.dataTransfer.setData('columnIndex', index);
    };

    // Function to handle drag over
    const handleDragOver = (e) => {
        e.preventDefault(); // Allow drop
    };
    // Function to handle drop
    const handleDrop = (e, index) => {
        const draggedIndex = e.dataTransfer.getData('columnIndex');
        if (draggedIndex !== index) {
            const newOrder = [...columnOrder];
            // Swap columns
            [newOrder[draggedIndex], newOrder[index]] = [newOrder[index], newOrder[draggedIndex]];
            setColumnOrder(newOrder);
        }
    };


    const grandTotal = data
        .filter((row) => row) // Ensure `data` is filtered correctly (e.g., remove null or undefined entries)
        .reduce(
            (totals, rowData) => ({
                TotalCardAmount: parseFloat((totals.TotalCardAmount + (parseFloat(rowData.TotalCardAmount) || 0)).toFixed(2)),
                TotalCashAmount: parseFloat((totals.TotalCashAmount + (parseFloat(rowData.TotalCashAmount) || 0)).toFixed(2)),
                TotalUPIAmount: parseFloat((totals.TotalUPIAmount + (parseFloat(rowData.TotalUPIAmount) || 0)).toFixed(2)),
            }),
            {
                TotalCardAmount: 0,
                TotalCashAmount: 0,
                TotalUPIAmount: 0,
            }
        );

    return (


        <div className="w-full  mt-6 mx-auto custom-scrollbar" style={{ width: '95%', }}>
            <style>
                {`
                    .custom-scrollbar::-webkit-scrollbar {
                        width: 3px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-thumb {
                        background-color: #333;
                        border: 2px solid #555;
                        border-radius: 6px;
                    }

                    .custom-scrollbar::-webkit-scrollbar-track {
                        background-color: #ddd;
                        border-radius: 6px;
                    }
                    `}
            </style>

            <div className="w-full  mx-auto" style={{ marginTop: '-10px' }}>

                <h6
                    className="uppercase tracking-wide text-black flex-grow linkcolor"
                    style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}
                >
                    DESPATCH DETAILS
                </h6>

                <div className="flex mb-2" style={{ marginTop: '-30px', marginLeft: '35%' }}>
                    <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1 }}>
                        Route: <strong style={{ color: 'darkblue' }}>{route}</strong>
                    </h5>
                    <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                        Order Taken Date: <strong style={{ color: 'darkred' }}>{Corderdate && new Date(Corderdate).toLocaleDateString('en-GB')}</strong>
                    </h5>
                    <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                        Order Taken By:  <strong style={{ color: '#3E5879' }}>{orderTakenby}</strong>
                    </h5>
                    <h5 className="text-black" style={{ fontSize: '14px', flexGrow: 1, marginLeft: '1%' }}>
                        SalesMan: <strong style={{ color: '#32AFA9' }}>{salesman}</strong>
                    </h5>
                </div>
                <div className="flex justify-end">
                    <div style={{ marginRight: '10px' }}>
                        <input
                            className="shadow text-gray-700 leading-tight"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            onFocus={() => setIsFocused(true)}
                            onBlur={() => setIsFocused(false)}
                            style={{
                                width: isFocused ? '300px' : '200px',
                                height: '40px',
                                border: '1px solid #ccc',
                                borderRadius: '15px',
                                padding: '0 20px',
                                transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                outline: 'none',
                                borderColor: isFocused ? 'darkcyan' : '#ccc',
                                boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                marginTop: '-10px'
                            }}
                        />
                    </div>

                    <div className="w-1/4 mr-2" style={{ marginTop: '-10px', marginLeft: '2px' }}>
                        <Select
                            value={selectedTrip}
                            onChange={handleTripChange}
                            options={tripOptions}
                            placeholder="Select Trip"
                            isSearchable
                            styles={{
                                menu: (provided) => ({
                                    ...provided,
                                    zIndex: 1301, // Ensure dropdown appears above the sticky header
                                }),
                            }}
                        />
                    </div>
                    <Button
                        style={{
                            backgroundColor: '#C9E9D2',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleRefreshClick}
                        className="linkcolor"
                    >
                        <span>Refresh</span>
                    </Button>

                    <Button
                        style={{
                            backgroundColor: '#F8E8EE',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handleExportExcel}
                        className="linkcolor"
                    >
                        <span>Excel</span>
                    </Button>
                    <Button
                        style={{
                            backgroundColor: '#E8F3D6',
                            color: 'black',
                            height: '36px',
                            marginTop: '-10px',
                            marginLeft: '5px'

                        }}
                        onClick={handlePrint}
                        className="linkcolor"
                    >
                        <span>Print</span>
                    </Button>

                </div>

                {/* Table display */}
                <div className="mt-6">
                    {loading ? (
                        <CircularProgress />
                    ) : (
                        <React.Fragment>


                            <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.90%', width: '100%' }}>
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead sx={{ backgroundColor: 'whitesmoke', width: '2500px' }}>
                                            <TableRow>
                                                {columnOrder.map((col, index) => (
                                                    <TableCell
                                                        key={index}
                                                        style={{
                                                            padding: '3px',
                                                            cursor: 'move',
                                                            color: '#750E21',
                                                            fontWeight: 'bolder',
                                                            textTransform: 'uppercase',
                                                            fontSize: '11.5px',
                                                            textAlign: [
                                                                'UOM(kgs)',
                                                                'Bundle',
                                                                'Pieces',
                                                                'Quantity(No.Pieces)',
                                                                'Total Quantity(kgs)'
                                                            ].includes(col) ? 'right' : 'left',
                                                        }}
                                                        draggable
                                                        onDragStart={(e) => handleDragStart(e, index)}
                                                        onDragOver={handleDragOver}
                                                        onDrop={(e) => handleDrop(e, index)}
                                                    >
                                                        {col}
                                                    </TableCell>
                                                ))}
                                            </TableRow>
                                        </TableHead>


                                        <TableBody>
                                            {Array.isArray(processedData) && processedData.length > 0 ? (
                                                processedData.map((rowData, index) => {
                                                    const showOrderTypeName =
                                                        index === 0 || rowData.OrderTypeName !== searchfilteredData[index - 1]?.OrderTypeName;
                                                    const showProductCategory =
                                                        index === 0 || rowData.ProductCategory !== searchfilteredData[index - 1]?.ProductCategory;
                                                    const showCategory =
                                                        index === 0 || rowData.Category !== searchfilteredData[index - 1]?.Category;

                                                    const rowValues = {
                                                        'SL No': index + 1,
                                                        'Order Type': showOrderTypeName ? rowData.OrderTypeName || '' : '',
                                                        'PDT Category': showProductCategory ? rowData.ProductCategory || '' : '',
                                                        Category: showCategory ? rowData.Category || '' : '',
                                                        'Code': rowData.ItemCode || '',
                                                        Item: rowData.Item || '',
                                                        Kilogram: rowData.Kilogram || '',
                                                        Bundle: rowData.Bundle || '',
                                                        Pieces: rowData.Pieces || '',
                                                        Quantity: rowData.Quantity || '',
                                                        'Total Kilogram': rowData.TotalKilogram || '',
                                                        'Customer ID': rowData.CustomerId || '',
                                                        'Sale Remarks': rowData.SaleRemarks || '',
                                                    };

                                                    const isHighlightedRow =
                                                        rowData.OrderTypeName?.includes('Total') || rowData.ProductCategory === 'GRAND Total';

                                                    return (
                                                        <React.Fragment key={index}>
                                                            {/* Main Row */}
                                                            <TableRow
                                                                style={{
                                                                    backgroundColor: isHighlightedRow ? '#F5EFE3' : 'inherit',
                                                                }}
                                                            >
                                                                {Object.keys(rowValues).map((key) => (
                                                                    <TableCell
                                                                        key={key}
                                                                        sx={{
                                                                            fontSize: '13px',
                                                                            padding: '4px',
                                                                            // textAlign: 'left',
                                                                            textAlign: ['Kilogram', 'Bundle', 'Pieces', 'Quantity', 'Total Kilogram', 'Customer ID'].includes(key) ? 'right' : 'left',
                                                                            width: '20px',
                                                                        }}
                                                                    >
                                                                        {rowValues[key]}
                                                                    </TableCell>
                                                                ))}
                                                            </TableRow>


                                                        </React.Fragment>
                                                    );
                                                })
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={12} sx={{ textAlign: 'center' }}>
                                                        No data available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                        {/* Render Grand Total in Footer */}
                                        <TableFooter style={{ padding: '5px' }}>
                                            <TableRow>
                                                <TablePagination
                                                    rowsPerPageOptions={[15, 25, 50, 100, 150, 250, 350, 500]}
                                                    count={searchfilteredData.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handlePageChange}
                                                    onRowsPerPageChange={handleRowsPerPageChange}

                                                />
                                            </TableRow>


                                        </TableFooter>

                                    </Table>
                                </TableContainer>
                            </div>

                        </React.Fragment>
                    )}
                </div>

                <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10 ">
                        <div className="bg-green-100  p-6 rounded-lg shadow-lg" style={{ width: '1200px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto' }}>
                            <div className="flex justify-end mt-2">
                                <button className="close-button md:static md:mr-2" onClick={closeModal} style={{ marginTop: '-20px', color: 'black' }}>
                                    <Tooltip title="Close">
                                        <FaTimes />
                                    </Tooltip>
                                </button>
                            </div>
                            <h4 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'teal', fontWeight: 'bolder' }}>Ordered Items</h4>
                            <div className="used-items-container">

                            </div>
                        </div>
                    </div>
                </Modal>
            </div>


        </div >
    );
};
export default DespatchReport;
